import React from 'react';
import { useNavigate } from 'react-router-dom';
import PatientForm from './PatientForm';

const NewPatient = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    // Redirect to patients list after successful creation
    navigate('/patients/list');
  };

  const handleCancel = () => {
    // Go back to previous page
    navigate(-1);
  };

  return (
    <PatientForm
      patient={null}
      isModal={false}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  );
};

export default NewPatient; 